<button type="button" class="card" (click)="handleClick($event)">
  <div class="left-elements">
    <div class="investment-name">{{entityInvestment().name}}</div>
    <div class="details">
      @if (entityInvestment().type) {
        <div class="investment-type">{{entityInvestment().type}}</div>
      }
      @if (!entityInvestment().type) {
        <div class="investment-type fallback-text">(Empty)</div>
      }
      @if (entityInvestment().currency) {
        <div class="investment-currency">{{entityInvestment().currency}}</div>
      }
      @if (!entityInvestment().currency) {
        <div class="investment-currency fallback-text">(Empty)</div>
      }
    </div>
  </div>
  <div class="right-elements">
    <div class="investment-marketvalue">{{entityInvestment().marketValue.displayValue}}</div>
  </div>
</button>
